import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { take } from 'rxjs';
import { ApiService } from '../../api/services/api.service';
import { ProjectSetting } from '../../api/models/fraud.models';

@Injectable({
  providedIn: 'root'
})
export class ProjectSettingsService {
  public readonly settings: WritableSignal<ProjectSetting | undefined> = signal<ProjectSetting | undefined>(undefined);

  private readonly _apiService: ApiService = inject(ApiService);

  load(): void {
    this._apiService.getProjectSetting().pipe(take(1)).subscribe({
      next: (settings: ProjectSetting) => this.settings.set(settings)
    });
  }
}
